<template>
    <div class="box">
        <div class="box-head">
            <div class="head-name" :class="{'curName':curTab==0}" @click="setTabPane(0)">重点项目图</div>
            <div class="head-name" :class="{'curName':curTab==1}" @click="setTabPane(1)">综合交通项目</div>
            <div class="head-name" :class="{'curName':curTab==2}" @click="setTabPane(2)">公共服务设施项目</div>
            <div class="head-name" :class="{'curName':curTab==3}" @click="setTabPane(3)">复建安置点</div>
            <div class="head-name" :class="{'curName':curTab==4}" @click="setTabPane(4)">自筹项目</div>
        </div>
        <div class="box-table">
            <baidu-map class="map-box" :center="center" :zoom="14" @ready="handler" @click="getClickInfo">
                <bm-ground :bounds="{ne: {lng: 117.240030, lat: 31.90559}, sw:{lng: 117.038881000, lat: 31.792470000}}" :opacity='0.7' :imageURL="mapURL">
                </bm-ground>
                <bm-marker v-for="item in points" :top="true" @click="clickHandler(item.id)" :key="item.id" :position="item.position" :zIndex='999999' :icon="{url: require('../../../assets/image/map_point.png'), size: {width: 50, height: 50}}">
                    <bm-info-window :position="item.position" :title="item.name" :show="curIndex==item.id" @close="infoWindowClose" style="width:300px;border:1px solid #ddd;padding:10px;">
                        <p style="margin:5px 0;">工期：{{item.allDay}}天 &nbsp;&nbsp;&nbsp;&nbsp; 剩余{{item.otherDay}}天({{item.progress}}%)</p>
                        <p style="margin:5px 0;">施工进度：{{item.progress}}%</p>
                        <button @click="clear(item)" style="background: #3371EC;border: 0;padding: 3px;color: #ffff;border-radius: 3px;">去查看</button>
                    </bm-info-window>
                </bm-marker>
            </baidu-map>
        </div>
    </div>
</template>
<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            center: {
                lng: 117.140395,
                lat: 31.855084
            },
            map: {},
            opt:{
                name:'',
                entId:'',
                joinType:'3',
            },
            curIndex:undefined,
            curTab : 0,//菜单
            points:[],
            imgs:[
                {id:0,url:'http://47.100.89.71:18004/static/wisdom/wechat/map/5.jpg'},
                {id:1,url:'http://47.100.89.71:18004/static/wisdom/wechat/map/1.jpg'},
                {id:2,url:'http://47.100.89.71:18004/static/wisdom/wechat/map/2.jpg'},
                {id:3,url:'http://47.100.89.71:18004/static/wisdom/wechat/map/3.jpg'},
                {id:4,url:'http://47.100.89.71:18004/static/wisdom/wechat/map/4.jpg'},
            ],
            mapURL:'http://47.100.89.71:18004/static/wisdom/wechat/map/2.jpg',
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
    },
    methods:{
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.map.enableScrollWheelZoom();
            this.getData()
        },
        getClickInfo(e){
            console.log(e)
        },

        //点击方法
        clickHandler(e){
            this.curIndex = e
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //查看
        clear(row){
            util.session.set('proId', row.id)
            util.session.set('backPage', '5')
            var that = this
            setTimeout(function() {
                that.$router.push({ path: '/entProInfo' })
            }, 0)
        },

        showMarker(list){
            var points = [];
            for (var i = 0; i < list.length; i++) {
                if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                    var obj = list[i]
                    var position = list[i].gpsPoint.split(',')
                    obj.position = {lng: position[0], lat: position[1]}
                    obj.typeName = list[i].projectType=='1'?'房建':'市政'
                    
                    if(list[i].allDay){
                        var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                        obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                    }else{
                        obj.progress = 0
                    }
                    points.push(obj)
                }
            }
            //console.log(points)
            //this.center = points.length>0?points[0].position:this.center
            this.points = points
        },
        //获取数据
        getData(){
            var that = this
            this.opt.entId = this.groupId
            myHttp.getProjectListByEntIdAndJoinType(this.opt).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projects = list
                    that.showMarker(list)
                }
            })
        },
        //
        setTabPane(index){
            this.curTab = index
            for(var i=0;i<this.imgs.length;i++){
                if(this.imgs[i].id==index){
                    this.mapURL = this.imgs[i].url
                }
            }
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width:100%;
        position: relative;
        height: calc( 100vh - 170px );
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
        background: #001498;
    }
    .head-name{
        display: flex;
        align-items: center;
        color: #AECFDC;
        font-size: 18px;
        padding: 0 20px;
        cursor: pointer;
    }
    .head-name:hover,.curName{
        background: #02106b;
        color: #fff;
    }
    .box-table{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>
<style>
    .map-box div{
        z-index: 400 ;
    }
</style>